module.exports = __webpack_public_path__ + "assets/img/title.3786c8eb.png";